/**
 * lib/titresPages.js — titre de l'onglet pour chaque route du module Bourse d'Idées.
 * Appliqué par components/SuiviPages.js.
 */

export const SUFFIXE_TITRE = 'Innovactive360';
export const SITE = 'https://app.bourse-idees.innovactive360.cloud';

export const DESCRIPTION_PAR_DEFAUT =
  "Bourse d'Idées Innovactive360° : projets d'entrepreneurs, appels à projets et financements au Bénin et en Afrique de l'Ouest.";

/**
 * Pages publiques indexables par Google, avec leur description (160 caractères au plus).
 * Le titre vient de TITRES ci-dessous. Toutes les autres pages reçoivent « noindex ».
 * Nouvelle page publique = une entrée ici, une ligne « Allow » dans public/robots.txt et une
 * adresse dans public/sitemap.xml.
 */
const DESCRIPTIONS = {
  '/': "Entrepreneurs et investisseurs du Bénin et d'Afrique de l'Ouest : publiez votre projet, trouvez un financement et répondez aux appels à projets.",
  '/projects': "Projets d'entrepreneurs du Bénin et d'Afrique de l'Ouest à la recherche d'investisseurs, de partenaires ou d'un financement.",
  '/call-for-projects': "Appels à projets, concours et subventions pour entrepreneurs en Afrique francophone : dates limites, conditions et lien pour candidater.",
  '/financing': "Prêts, microfinance, fonds de garantie et investisseurs : les offres de financement pour les entreprises du Bénin et d'Afrique de l'Ouest.",
  '/login': "Connectez-vous à la Bourse d'Idées Innovactive360° pour suivre vos projets et vos candidatures.",
  '/register': "Créez votre compte sur la Bourse d'Idées Innovactive360° pour publier un projet et candidater aux appels à projets.",
};

// Pages de détail publiques (un projet, un appel, une offre de financement)
const PREFIXES_PUBLICS = ['/projects/', '/call-for-projects/', '/financing/'];
// Pages de gestion à ne pas indexer même sous un préfixe public
const PRIVES = [/^\/projects\/create$/, /\/edit$/, /^\/call-for-projects\/create$/];

export function normaliserChemin(chemin) {
  return chemin.replace(/\/+$/, '') || '/';
}

export function estIndexable(chemin) {
  const c = normaliserChemin(chemin);
  if (PRIVES.some((re) => re.test(c))) return false;
  return Object.prototype.hasOwnProperty.call(DESCRIPTIONS, c) || PREFIXES_PUBLICS.some((p) => c.startsWith(p));
}

export function descriptionPourChemin(chemin) {
  return DESCRIPTIONS[normaliserChemin(chemin)] || DESCRIPTION_PAR_DEFAUT;
}
const TITRE_MODULE = "Bourse d'Idées";

const TITRES = {
  "/": "Bourse d'Idées : projets, appels à projets et financements",
  "/projects": "Projets d’entrepreneurs à financer au Bénin",
  "/projects/create": "Nouveau projet - Bourse d'Idées",
  "/my-projects": "Mes projets - Bourse d'Idées",
  "/call-for-projects": "Appels à projets en Afrique de l'Ouest",
  "/call-for-projects/create": "Nouvel appel à projets",
  "/my-applications": "Mes candidatures",
  "/financing": "Financer sa PME au Bénin et en Afrique de l'Ouest",
  "/favorites": "Favoris - Bourse d'Idées",
  "/matching": "Mise en relation - Bourse d'Idées",
  "/messaging": "Messagerie - Bourse d'Idées",
  "/contacts": "Contacts - Bourse d'Idées",
  "/dashboard": "Tableau de bord - Bourse d'Idées",
  "/profile": "Mon profil - Bourse d'Idées",
  "/users": "Profils - Bourse d'Idées",
  "/subscriptions": "Abonnements - Bourse d'Idées",
  "/payment": "Paiement - Bourse d'Idées",
  "/admin": "Administration - Bourse d'Idées",
  "/super-admin": "Super administration - Bourse d'Idées",
  "/login": "Connexion - Bourse d'Idées",
  "/register": "Inscription - Bourse d'Idées",
};

/** Titre complet de l'onglet pour un chemin (préfixe le plus long), ex. « Appels à projets - Innovactive360 ». */
export function titrePourChemin(chemin) {
  let partie = chemin.replace(/\/+$/, '') || '/';
  for (;;) {
    const titre = TITRES[partie];
    if (titre) return `${titre} - ${SUFFIXE_TITRE}`;
    if (partie === '/') return `${TITRE_MODULE} - ${SUFFIXE_TITRE}`;
    const i = partie.lastIndexOf('/');
    partie = i <= 0 ? '/' : partie.slice(0, i);
  }
}
